import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import {CommonModule} from "@angular/common";
import {BootstrapIcon} from "src/app/services/header.service";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {debounceTime, distinctUntilChanged, map} from "rxjs";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatTooltipModule} from "@angular/material/tooltip";

@Component({
  selector: "app-search-filter-bar",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule
  ],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="d-flex align-items-center gap-2">
      <div
        class="back-button flex-shrink-0 d-flex align-items-center"
        *ngIf="this.useBackNavigation"
      >
        <i
          [class]="BootstrapIcon.back_arrow"
          class="cursor-pointer display-6"
          (click)="back()"
        ></i>
      </div>
      <div
        class="search-bar flex-grow-1 density-settings-4"
        *ngIf="this.useSearchBar"
      >
        <form [formGroup]="searchBarForm">
          <mat-form-field
            subscriptSizing="dynamic"
            class="w-100"
            [ngClass]="{'mat-elevation-z8 rounded-3': isDashboard}"
            appearance="outline"
          >
            <input matInput formControlName="searchTerm" placeholder="Suche" (keyup.enter)="triggerSearch()"/>
            <i matPrefix [class]="BootstrapIcon.search" class="ps-3 pe-2 cursor-pointer" (click)="triggerSearch()"></i>
          </mat-form-field>
        </form>
      </div>
      <div
        class="filter-button flex-shrink-0 d-flex p-0 m-0 align-items-center"
        [ngClass]="{'p-3 mat-elevation-z8 dashboard-filter-icon': isDashboard}"
        *ngIf="this.useFilter"
      >
        <i
          [class]="BootstrapIcon.filter"
          class="filter-icon cursor-pointer display-6"
          (click)="toggleFilter()"
          matTooltip="Filter"
        ></i>
      </div>
      <div
        class="statistics-button flex-shrink-0 d-flex p-0 m-0 align-items-center"
        *ngIf="this.useStatistics"
      >
        <i
          [class]="BootstrapIcon.pie_chart"
          class="statistics-icon cursor-pointer"
          (click)="toggleDiagram()"
          matTooltip="Diagramm"
        ></i>
      </div>
    </div>
  `,
  styles: [`
    .dashboard-filter-icon {
      height: 40px;
      width: 40px;
      color: #9f9f9f;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(0, 0, 0, 0.43);
      border-radius: 4px;

      .filter-icon {
        font-size: 2.5rem;
        font-weight: 300;
        line-height: 0.9;
        padding: 1rem;
      }
    }

    .statistics-icon {
      font-size: calc(0.75rem + 1.2vw);
      font-weight: 300;
      line-height: 0.9;
    }
  `],
})
export class SearchFilterBarComponent {
  BootstrapIcon = BootstrapIcon;
  @Input() useBackNavigation: boolean = true;
  @Input() useSearchBar: boolean = true;
  @Input() useFilter: boolean = true;
  @Input() useStatistics: boolean = false;
  @Input() isDashboard: boolean = false;

  @Output() navigateBack = new EventEmitter<void>();
  @Output() toggleFilterEvent = new EventEmitter<void>();
  @Output() toggleDiagramEvent = new EventEmitter<void>();
  @Output() valueChange = new EventEmitter<string>();
  @Output() startSearch: EventEmitter<void> = new EventEmitter<void>();

  searchBarForm = new FormGroup({
    searchTerm: new FormControl(""),
  });

  public resetForm() {
    this.searchBarForm.reset();
  }

  searchTerm$ = this.searchBarForm
    .get("searchTerm")
    ?.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      map((value) => value?.trim() || "")
    )
    .subscribe((value) => this.valueChange.emit(value));

  back() {
    this.navigateBack.emit();
  }

  toggleFilter() {
    this.toggleFilterEvent.emit();
  }

  toggleDiagram() {
    this.toggleDiagramEvent.emit()
  }

  triggerSearch() {
    if (this.searchBarForm.get('searchTerm')?.value) {
      this.startSearch.emit();
    }
  }
}
